// utils/errorLogger/classify.ts - utils/errorLogger.ts split (sub-module classify)


import type {ErrorType} from './types.js';
import { PRIORITY_CONTEXTS } from './rateLimit.js';


/**
 * Determine error type from error object
 */
export const getErrorType = (error: Error | unknown): ErrorType => {
    if (error instanceof Error) {
        const message = error.message.toLowerCase();

        // Network errors
        if (message.includes('network') ||
            message.includes('fetch') ||
            message.includes('timeout') ||
            message.includes('connection') ||
            message.includes('failed to fetch')) {
            return 'network';
        }

        // Authentication errors
        if (message.includes('auth') ||
            message.includes('unauthorized') ||
            message.includes('forbidden') ||
            message.includes('permission') ||
            message.includes('token')) {
            return 'authentication';
        }

        // Validation errors
        if (message.includes('validation') ||
            message.includes('invalid') ||
            message.includes('required') ||
            message.includes('must be')) {
            return 'validation';
        }

        return 'runtime';
    }

    return 'unknown';
};



/**
 * Log error to Supabase
 * Rate limited to prevent spam (max 10 errors per minute)
 */
export const isPriorityContext = (context?: string): boolean => {
    return PRIORITY_CONTEXTS.some(c => context?.includes(c));
};
